import { Store } from '@webtides/element-js';

const UserCentrics = {
    isConsentRequired: () => {
        return window.UC_UI && window.UC_UI?.isConsentRequired();
    },
    hasGoogleMapsConsent: () => {
        if ((window.UC_UI && window.UC_UI?.isInitialized()) === false) {
            return false;
        }
        const maps = window.UC_UI?.getServicesBaseInfo().find(data => data.name === 'Google Maps');
        return maps?.consent?.status ?? false;
    },
    hasGoogleReCaptcha: () => {
        if ((window.UC_UI && window.UC_UI?.isInitialized()) === false) {
            return false;
        }
        const recaptcha = window.UC_UI?.getServicesBaseInfo().find(data => data.name === 'reCaptcha v3');
        return recaptcha?.consent?.status ?? false;
    },
    findServicesById: id => {
        if ((window.UC_UI && window.UC_UI?.isInitialized()) === false) {
            return false;
        }

        const serviceProvider = window.UC_UI?.getServicesBaseInfo().find(data => data.id === id);
        return serviceProvider?.consent?.status ?? false;
    },
};

export default UserCentrics;

class UCStore extends Store {
    constructor() {
        super();
        window.addEventListener('UC_UI_INITIALIZED', () => {
            this.updateConsent();
            this.isInitialized = true;
        });
        window.addEventListener('UC_UI_VIEW_CHANGED', () => this.updateConsent());
    }

    updateConsent() {
        this.hasGoogleMapsConsent = UserCentrics.hasGoogleMapsConsent();
        this.hasGoogleReCaptcha = UserCentrics.hasGoogleReCaptcha();
    }

    findConsentById(id) {
        return UserCentrics.findServicesById(id);
    }

    properties() {
        return {
            hasGoogleMapsConsent: false,
            hasGoogleReCaptcha: false,
            isInitialized: false,
        };
    }

    openConsentLayer() {
        window.UC_UI?.showSecondLayer();
    }
}
export const ucStore = new UCStore();
